module.exports = __webpack_public_path__ + "static/media/apple-button.01b6e171.png";